import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';

// Redux
import { connect } from 'react-redux';
import { closeForgotPasswordModal, openLoginModal } from '../../actions/modalActions';

// Components
import ForgotPasswordForm from './ForgotPasswordForm';

// Locale
import messages from '../../locale/jsonMessages';
// Image
import bgImage from '/public/siteImages/forgotCarBg.png';

import cs from '../../components/commonStyle.css';
import c from '../../components/LoginModal/LoginModal.css';
import s from './ForgotPassword.css';

const ForgotPassword = ({ closeForgotPasswordModal, openLoginModal, forgotModal }) => {
  return (
    <Modal
      show={forgotModal}
      animation={false}
      onHide={closeForgotPasswordModal}
      dialogClassName='commonModalContainer loginFormModal'
    >
      <div className={c.carImage} style={{ backgroundImage: `url(${bgImage})` }} />
      <div>
        <Modal.Header closeButton />
        <Modal.Body bsClass={cs.spaceTop5}>
          <h4 className={cx(cs.commonSubTitleText, cs.paddingBottom2, cs.fontWeightBold)}>
            <FormattedMessage {...messages.resetPassword} />
          </h4>
          <ForgotPasswordForm openLoginModal={openLoginModal} />
        </Modal.Body>
      </div>
    </Modal>
  );
};

ForgotPassword.propTypes = {
  closeForgotPasswordModal: PropTypes.func,
  forgotModal: PropTypes.bool,
  openLoginModal: PropTypes.func,
  formatMessage: PropTypes.func,
};

const mapState = (state) => ({
  forgotModal: state.modalStatus.isForgotPasswordOpen,
});

const mapDispatch = {
  closeForgotPasswordModal,
  openLoginModal,
};

export default injectIntl(withStyles(cs, c, s)(connect(mapState, mapDispatch)(ForgotPassword)));
